import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { SHOW_MEMORY_PAGE } from "../lib/navFlags.js";
import { NavCountBadge } from "./PendingApprovals";

export default function MobileDrawer({
  open,
  onClose,
  isPlatformAdmin = false,
  pendingApprovalsCount = 0,
}) {
  const loc = useLocation();

  // close when route changes (e.g., user tapped a link)
  React.useEffect(() => { if (open) onClose?.(); /* eslint-disable-next-line */ }, [loc.pathname]);

  // close on ESC
  React.useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  // lock background scroll while open
  React.useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, [open]);

  return (
    <>
      <div
        className={`drawerOverlay ${open ? "open" : ""}`}
        onClick={onClose}
      />
      <aside
        id="mobile-drawer"
        className={`drawer ${open ? "open" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-label="Main menu"
      >
        <div className="drawerHeader">
          <div className="brand">BossDrop.ai</div>
          <button className="closeBtn" onClick={onClose} aria-label="Close menu">
            <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        <nav className="drawerNav" onClick={(e) => {
          const a = e.target.closest("a"); if (a) onClose?.();
        }}>
          <NavLink to="/control-room">Control Room</NavLink>
          {/* Memory can be switched off (lib/navFlags.js). */}
          {SHOW_MEMORY_PAGE ? <NavLink to="/memory">Memory</NavLink> : null}
          <NavLink to="/audit-logs">
            Audit Logs
            <NavCountBadge count={pendingApprovalsCount} />
          </NavLink>
          <NavLink to="/kpis">KPIs</NavLink>
          <NavLink to="/account">Account</NavLink>
          {/* Same order and same gate as the desktop sidebar: BossDrop's own
              admin area, last, and only for a platform admin. */}
          {isPlatformAdmin ? <NavLink to="/clients">Clients</NavLink> : null}
        </nav>

        <button className="wideBtn" onClick={onClose}>Close</button>
        <div className="drawerFoot">© {new Date().getFullYear()} BossDrop</div>
      </aside>
    </>
  );
}
